<template>
    <div class="order-detail-section mg20">
        <h3>发票信息</h3>
        <el-table :data="test" border style="margin:20px; width:97%">
            <el-table-column label="修订项" prop="title">
                <template slot-scope="scope">
                    {{scope.row.col_name}}
                </template>
            </el-table-column>
            <el-table-column label="修订后内容"  prop="ccc">
                <template slot-scope="scope">
                    <span v-html=scope.row.new_content></span>
                </template>
            </el-table-column>
            <el-table-column label="原内容" prop="bbb">
                <template slot-scope="scope" >
                    <span v-html=scope.row.old_content></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {OrderMixin} from "~/services/OrderMixin";
    import OrderService from '~/services/order';
    export default {
        name: "invoice",
        mixins: [OrderMixin],
        props: {
            order: {
                required: true
            },
            oldOrder: {
                required: false
            }
        },
        watch: {
            order(v, s) {
                if(this.order.content){
                    this.test = this.order.content.invoice.map(item=> {
                        item.col_name = '新增发票';
                        if(item.created_at){
                            item.col_name = '发票ID:'+item.id;
                        }
                        item.old_content = '无';
                        let old = this.order.before_content.finance.invoice.find(i=>{
                            return i.id == item.id
                        })
                        item.new_content = this.getContent(item,old);
                        if(old){
                            item.old_content = this.getContent(old);
                        }else{
                            item.new_content  = '<span style="color: red">'+item.new_content+'</span>'
                        }
                        return item;
                    });

                    /**
                     * 有可能有删除的情况存在
                     * 需要查找出删除的回款信息
                     */
                    let active_invoice = [];
                    this.test.map(i=>{
                        active_invoice.push(i.id);
                    })
                    let del_invoice = this.order.before_content.finance.invoice.filter(item=>{
                        return !active_invoice.includes(item.id);
                    })
                    if(del_invoice){//说明有删除的
                        del_invoice.map(item=>{
                            item.old_content = this.getContent(item);
                            item.new_content = '<span style="color: red">已删除</span>'
                            item.col_name = "删除发票";
                            this.test.push(item);
                        })
                    }
                }
            }
        },
        created(){
            //this.invoiceTypes = OrderService.invoiceTypes();
          var context = OrderService.myInvoiceContext();
          context.then(res => {
            this.invoiceTypes = res.data;
          });
        },
        data() {
            return {
                invoiceTypes:[],
                test:[
                    {
                        field:'main',
                        col_name:'发票ID',
                        new_content:'',
                        old_content:'',
                    }
                ],
                type:[
                    "普通发票(纸质)",
                    "专用发票(纸质)",
                    "普通发票(电子)",
                    "专用发票(电子)"
                ]
            }
        },
        methods:{
            getContent(item,old=false){
                let content = '';
                // 确保item.content是字符串类型进行比较
                const contentStr = String(item.content);
                let invoice_content = this.invoiceTypes.find(i=>{
                    return String(i.value) === contentStr;
                }) || { label: contentStr }; // 如果没找到则使用原值
                
                // 确保类型索引在有效范围内
                const typeIndex = item.type > 0 && item.type <= this.type.length ? item.type - 1 : 0;
                let typeText = this.type[typeIndex] || `未知类型(${item.type})`;
                let invoice_type = "发票类型:" + typeText + "<br/>";
                
                let invoice_title = "发票抬头:"+item.title+"<br/>";
                let invoice_content_memo = "开票内容:"+invoice_content.label+"<br/>";
                
                let getDetailsStr = (obj) => {
                    let arr = [];
                    if (Array.isArray(obj.details) && obj.details.length > 0) {
                        arr = obj.details;
                    } else if (Array.isArray(obj.detail) && obj.detail.length > 0) {
                        arr = obj.detail;
                    } else if (Array.isArray(obj.open_details) && obj.open_details.length > 0) {
                        arr = obj.open_details;
                    }

                    if (arr.length === 0) return '';
                    let str = '开票明细:';
                    arr.forEach(d => {
                        if (typeof d === 'string') {
                            str += d + ' ';
                        } else if (d && typeof d === 'object') {
                            let name = d.product_name || d.model || '';
                            let unit = d.unit || '';
                            let num = d.num || d.qty || '';
                            str += `${name}-${unit}-${num} `;
                        }
                    });
                    str += '<br/>';
                    return str;
                };
                let invoice_details = getDetailsStr(item);

                let invoice_total_amount = "开票金额:"+item.total_amount+"<br/>";
                let invoice_input_at = "开票日期:"+item.input_at+"<br/>";
                let taxpayer_id = "纳税人识别号:"+item.taxpayer_id+"<br/>";
                let taxpayer_account_name = "开户行:"+item.bank_name+"<br/>";
                let invoice_account = "账号:"+item.account+"<br/>";
                let invoice_mobile = "电话:"+item.mobile+"<br/>";
                let invoice_address = "地址:"+item.address+"<br/>";
                let at = '';
                if(item.file_list && item.file_list.length>0){
                    item.file_list.map(i=>{
                           at += "<a href="+"https://scrm.21cnjy.net/"+i.url+">"+i.name+""
                    })
                }else{
                     at = '无';
                }
                let invoice_attachment = "附件:"+at+"<br/>";
                let invoice_memo = "备注:"+item.memo+"<br/>";
                let invoice_email = "邮箱:"+item.email;
                if(old){
                    // 确保old.content是字符串类型进行比较
                    const oldContentStr = String(old.content);
                    let old_invoice_content = this.invoiceTypes.find(i=>{
                        return String(i.value) === oldContentStr;
                    }) || { label: oldContentStr }; // 如果没找到则使用原值
                    
                    // 确保老类型索引在有效范围内
                    const oldTypeIndex = old.type > 0 && old.type <= this.type.length ? old.type - 1 : 0;
                    let oldTypeText = this.type[oldTypeIndex] || `未知类型(${old.type})`;
                    let old_invoice_type = "发票类型:" + oldTypeText + "<br/>";
                    
                    let old_at = '';
                    if(old.file_list && old.file_list.length>0){
                        old.file_list.map(i=>{
                            old_at += "<a href="+"https://scrm.21cnjy.net/"+i.url+">"+i.name+""
                        })
                    }else{
                        old_at = '无';
                    }
                    let old_invoice_title = "发票抬头:"+old.title+"<br/>";
                    let old_invoice_total_amount = "开票金额:"+old.total_amount+"<br/>";
                    let old_invoice_content_memo = "开票内容:"+old_invoice_content.label+"<br/>";
                    let old_invoice_details = getDetailsStr(old);
                    let old_invoice_input_at = "开票日期:"+old.input_at+"<br/>";
                    let old_taxpayer_id = "纳税人识别号:"+old.taxpayer_id+"<br/>";
                    let old_taxpayer_account_name = "开户行:"+old.bank_name+"<br/>";
                    let old_invoice_account = "账号:"+old.account+"<br/>";
                    let old_invoice_mobile = "电话:"+old.mobile+"<br/>";
                    let old_invoice_address = "地址:"+old.address+"<br/>";
                    let old_invoice_attachment = "附件:"+old_at+"<br/>";
                    let old_invoice_memo = "备注:"+old.memo+"<br/>";
                    let old_invoice_email = "邮箱:"+old.email;

                    if(invoice_type != old_invoice_type){
                        invoice_type  = '<span style="color: red">'+invoice_type+'</span>'
                    }
                    if(invoice_title != old_invoice_title){
                        invoice_title  = '<span style="color: red">'+invoice_title+'</span>'
                    }
                    if(invoice_total_amount != old_invoice_total_amount){
                        invoice_total_amount  = '<span style="color: red">'+invoice_total_amount+'</span>'
                    }
                    if(invoice_content_memo != old_invoice_content_memo){
                        invoice_content_memo  = '<span style="color: red">'+invoice_content_memo+'</span>'
                    }
                    if(invoice_details != old_invoice_details){
                        invoice_details  = '<span style="color: red">'+invoice_details+'</span>'
                    }
                    if(invoice_input_at != old_invoice_input_at){
                        invoice_input_at  = '<span style="color: red">'+invoice_input_at+'</span>'
                    }
                    if(taxpayer_id != old_taxpayer_id){
                        taxpayer_id  = '<span style="color: red">'+taxpayer_id+'</span>'
                    }
                    if(taxpayer_account_name != old_taxpayer_account_name){
                        taxpayer_account_name  = '<span style="color: red">'+taxpayer_account_name+'</span>'
                    }
                    if(invoice_account != old_invoice_account){
                        invoice_account  = '<span style="color: red">'+invoice_account+'</span>'
                    }
                    if(invoice_mobile != old_invoice_mobile){
                        invoice_mobile  = '<span style="color: red">'+invoice_mobile+'</span>'
                    }
                    if(invoice_address != old_invoice_address){
                        invoice_address  = '<span style="color: red">'+invoice_address+'</span>'
                    }
                    if(invoice_attachment != old_invoice_attachment){
                        invoice_attachment  = '<span style="color: red">'+invoice_attachment+'</span>'
                    }
                    if(invoice_memo != old_invoice_memo){
                        invoice_memo  = '<span style="color: red">'+invoice_memo+'</span>'
                    }
                    if(invoice_email != old_invoice_email){
                        invoice_email  = '<span style="color: red">'+invoice_email+'</span>'
                    }
                }
                content += invoice_type;
                content += invoice_title;
                content += invoice_content_memo;
                content += invoice_details;
                content += invoice_total_amount;
                content += invoice_input_at;
                content += taxpayer_id;
                if(item.type==2){
                    content += taxpayer_account_name;
                    content += invoice_account;
                    content += invoice_mobile;
                    content += invoice_address;
                    content += invoice_attachment;
                    content += invoice_memo;
                }
                if(item.type==3){
                    content += invoice_email;
                }
                return content;
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order/finance/invoice.vue